/**
 * Web guide status registry.
 *
 * Notes:
 * - Enum only; keep business flow documentation in JSDoc.
 * - Key values use underscore format; do not use dotted paths.
 */
export enum GuideRegistryKey {
  // P0
  LIVE_STUDIO_HAS_VISITED_CHAT = 'web_live_studio_has_visited_chat',
  LIVE_STUDIO_GUIDE_SHOWN = 'web_live_studio_guide_shown',
  LIVE_STUDIO_LAST_USED = 'web_live_studio_last_used',
  LIVE_STUDIO_RED_DOT_SEEN_20251110 = 'web_live_studio_red_dot_seen_20251110',
  STORY_FIRST_ENTER_SHOWN = 'web_story_first_enter_shown',
  STORY_HAS_ENTERED = 'web_story_has_entered',
  MODEL_FIRST_CHOOSE_SHOWN = 'web_model_first_choose_shown',
  VOICE_PLAY_CONFIRMED = 'web_voice_play_confirmed',
  RELATIONSHIP_GUIDE_SHOWN = 'web_relationship_guide_shown',
  RELATIONSHIP_DOWNLOAD_GUIDE_SHOWN = 'web_relationship_download_guide_shown',
  PROFILE_GENDER_SELECTED = 'web_profile_gender_selected',
  EVENTS_MAY_BALL_CHAT_FLOWER_GUIDE_SHOWN = 'app_events_may_ball_chat_flower_guide_shown',
  // 开屏 PV 已观看（与 App 端共享同一状态，值为 Record<pvId, boolean>，任一端看过跨端不再弹）
  EVENTS_MAY_BALL_SPLASH_PV_WATCHED = 'app_events_may_ball_splash_pv_watched',
  EVENTS_TIDAL_HEARTS_CHAT_COCKTAIL_GUIDE_SHOWN = 'app_events_tidal_hearts_chat_cocktail_guide_shown',
  EVENTS_TIDAL_HEARTS_MOBILE_SEND_DRINK_APP_REMINDER_SHOWN = 'web_events_tidal_hearts_mobile_send_drink_app_reminder_shown',
  EVENTS_ORACLES_CALL_CHAT_POTION_GUIDE_SHOWN = 'app_events_july_tarot_chat_potion_guide_shown',
  EVENTS_ORACLES_CALL_POTION_MIXED_PAYMENT_CONFIRMED = 'app_events_july_tarot_potion_mixed_payment_confirmed',

  // P1
  MEDIA_AUTO_GEN_MODAL_IMAGE_V2 = 'common_media_auto_gen_modal_image',
  MEDIA_AUTO_GEN_MODAL_VIDEO = 'common_media_auto_gen_modal_video',
  MEDIA_AUTO_GEN_MODAL_AUDIO = 'web_media_auto_gen_modal_audio',
  MEDIA_FIRST_GEN_TIP_IMAGE = 'web_media_first_gen_tip_image',
  MEDIA_FIRST_GEN_TIP_VIDEO = 'web_media_first_gen_tip_video',
  MEDIA_FIRST_GEN_CONFIRM_IMAGE = 'common_media_first_gen_confirm_image',
  MEDIA_FIRST_GEN_CONFIRM_VIDEO = 'common_media_first_gen_confirm_video',
  MEDIA_VIDEO_SOUND_GUIDE_MOBILE_FIRST = 'web_media_video_sound_guide_mobile_first',
  MEDIA_VIDEO_SOUND_GUIDE_MOBILE_AUTO = 'web_media_video_sound_guide_mobile_auto',
  MEDIA_VIDEO_SOUND_GUIDE_DESKTOP_FIRST = 'web_media_video_sound_guide_desktop_first',
  MEDIA_VIDEO_SOUND_GUIDE_DESKTOP_AUTO = 'web_media_video_sound_guide_desktop_auto',
  SUBSCRIPTION_NEW_USER_MODAL_SHOWN = 'web_subscription_new_user_modal_shown',

  // P2
  LEVEL_FIRST_BANNER_SHOWN = 'web_level_first_banner_shown',
  LEVEL_REWARD_TOOLTIP_SHOWN = 'web_level_reward_tooltip_shown',
  LEVEL_CALENDAR_REWARD_TOOLTIP_SHOWN = 'web_level_calendar_reward_tooltip_shown',
  // Memory guide trigger state (trigger when used_context_length >= current session context_length threshold)
  CHAT_MEMORY_LIMIT_GUIDE_LAST_TRIGGER_AT = 'common_chat_memory_limit_guide_last_trigger_at',
  CHAT_MEMORY_LIMIT_GUIDE_TRIGGER_COUNT = 'common_chat_memory_limit_guide_trigger_count',
  CHAT_SETTINGS_RED_DOT_VIEWED = 'web_chat_settings_red_dot_viewed',
  CHAT_SETTINGS_VIDEO_SOUND_VIEWED = 'web_chat_settings_video_sound_viewed',
  CHAT_SETTINGS_FONT_SIZE_VIEWED = 'web_chat_settings_font_size_viewed',
  CREATE_IMAGE_TO_LINK_VIEWED = 'web_create_image_to_link_viewed',

  // User-closed modals
  MODALS_PROMOTIONS_SUMMER_SALE = 'web_modals_promotions_summer_sale',
  MODALS_APP_DOWNLOAD_HOME_BANNER = 'web_modals_app_download_home_banner',

  /**
   * Chat Archives 入口迁移引导：上线前注册的老用户，14 天窗口内首次打开
   * 聊天菜单时展示一次，告知三个旧入口已合并到 Chat Archives。
   * 仅 Web 端使用，与 App 端不强制跨端同步。
   */
  CHAT_ARCHIVES_MIGRATION_GUIDE_SHOWN = 'web_chat_archives_migration_guide_shown',

  // World 模拟器「长按拖动」引导（与 App 端共享同一状态，跨端只展示一次）
  SIMULATOR_GAME_DRAG_TIP_SHOWN = 'common_simulator_game_drag_tip_shown',

  // One-time migration flag
  WEB_MIGRATE_DONE_V1 = 'web_migrate_done_v1',
}

export const GUIDE_REGISTRY_KEYS = Object.values(GuideRegistryKey)
